var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverwriteSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2473_8342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.75L15.75 3.75M15.75 3.75L12.75 6.75M15.75 3.75H5.25C4.45435 3.75 3.69129 4.06607 3.12868 4.62868C2.56607 5.19129 2.25 5.95435 2.25 6.75V8.25M5.25 17.25L2.25 14.25M2.25 14.25L5.25 11.25M2.25 14.25H12.75C13.5456 14.25 14.3087 13.9339 14.8713 13.3713C15.4339 12.8087 15.75 12.0456 15.75 11.25V9.75",
    stroke: "#FFC107",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2473_8342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverwriteSvg);
export default __webpack_public_path__ + "static/media/OverwriteSvg.2e4b06ac94765249fbb13952512d36bf.svg";
export { ForwardRef as ReactComponent };